import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { BaseIcon } from '../../../components/base-icon.mjs';

const SvgQuestionCircle = forwardRef((props, ref) => /* @__PURE__ */ jsx(BaseIcon, { fill: "currentColor", ref, ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    d: "M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12m9.008-3.018a1.502 1.502 0 0 1 2.522 1.159v.024a1.44 1.44 0 0 1-1.493 1.418 1 1 0 0 0-1.037.999V14a1 1 0 1 0 2 0v-.539a3.44 3.44 0 0 0 2.529-3.256 3.502 3.502 0 0 0-7-.255 1 1 0 0 0 2 .076c.014-.398.187-.774.48-1.044Zm.982 7.026a1 1 0 1 0 0 2H12a1 1 0 1 0 0-2z",
    clipRule: "evenodd"
  }
) }));

export { SvgQuestionCircle as default };
//# sourceMappingURL=question-circle.mjs.map
